import React, { useState, useEffect } from 'react';
import { setDefaults, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Redirect, useHistory } from "react-router-dom";
import { getAxiosConfig } from '../utils/apiUtils';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import SideNav, { Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import Seasons from './subroutes/seasons';
import ExploreRoute from './subroutes/explore';
import ExperienceRoute from './subroutes/experience';
import SeasonRoute from './subroutes/season';
import CategoryRoute from './subroutes/category';
import { getLoggedInUser } from '../utils/authUtils';

import searchIcon from '../assets/images/lupa.svg';
import seasonIcon from '../assets/images/stations.svg';
import storiesIcon from '../assets/images/Cuentos.svg';
import puppetsIcon from '../assets/images/stories-puppets.svg';
import songsIcon from '../assets/images/songs.svg';
import poemsIcon from '../assets/images/poetry.svg';
import meetIcon from '../assets/images/Conozcamos.svg';
import craftsIcon from '../assets/images/Manualidades.svg';
import workshopsIcon from '../assets/images/Talleres.svg';
import gamesIcon from '../assets/images/Juegos.svg';
import othersIcon from '../assets/images/Otros.svg';
import chungungoLogo from '../assets/images/logotipo-chungungo-flor.svg';
import chungungoLogoMobile from '../assets/images/chungungo_brand.svg';
import userIcon from '../assets/images/perfil.svg';
import { Button, Form, FormControl, Navbar } from 'react-bootstrap';
import LoginModal from '../components/loginModal';
import Register from './register';
import footerLogo from '../assets/images/isotipo-footer.svg';
import Account from './account';
import SubscribeSuccess from './subroutes/subscribe_success';
import SuscribeConfirm from './subroutes/subscribe_confirm';
import Invoices from './subroutes/invoices';
import {useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import '../index.css';
import Subscribe from './subscribe';
import { reportEvent } from '../utils/analyticsUtils';
import { Autoplay } from 'swiper';

const menuItems = [
  {
    eventKey: 'seasons',
    icon: seasonIcon,
  },
  {
    eventKey: 'stories',
    icon: storiesIcon,
  },
  {
    eventKey: 'puppets',
    icon: puppetsIcon,
  },
  {
    eventKey: 'songs',
    icon: songsIcon,
  },
  {
    eventKey: 'poems',
    icon: poemsIcon,
  },
  {
    eventKey: 'meet',
    icon: meetIcon,
  },
  {
    eventKey: 'crafts',
    icon: craftsIcon,
  },
  {
    eventKey: 'workshops',
    icon: workshopsIcon,
  },
  {
    eventKey: 'games',
    icon: gamesIcon,
  },
  {
    eventKey: 'others',
    icon: othersIcon,
  },
];

const seasonsRoutes = [
  {
    exploreKey: 'featured'
  },
  {
    exploreKey: 'new'
  },
  {
    exploreKey: 'continue'
  },
  {
    exploreKey: 'mostwatched'
  },
  {
    exploreKey: 'visitagain'
  },
  {
    exploreKey: 'all'
  }
];

const navWidthExpanded = 240;

// SideNav
const StyledSideNav = styled(SideNav)`
    background-color: #fff;
    border-right: 1px solid #ddd;
`;
StyledSideNav.defaultProps = SideNav.defaultProps;

const NavHeader = styled.div`
    display: ${props => (props.expanded ? 'block' : 'none')};
    color: #fff;
    > * {
        color: inherit;
        background-color: inherit;
    }
`;

const Separator = styled.div`
    clear: both;
    position: relative;
    margin: .8rem 0;
    background-color: #ddd;
    height: 1px;
`;

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}


const MainLayout = (props) => {
  const { t } = useTranslation();

  const sendDataToGTM = useGTMDispatch()
  const [goToLogin, setGoToLogin] = useState();
  const [goToAccount, setGoToAccount] = useState();

  const [searchText, setSearchText] = useState('');
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [nowMobile, setNowMobile] = useState(dimensions.width <= 768);

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }, 500)

    window.addEventListener('resize', debouncedHandleResize)

    return _ => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  });

  const styles = {
    layout: {
      paddingRight: '16px',
    },
    sideMenu: {
      background: 'white',
    },
    mainLayout: {
      //marginLeft: dimensions.width <= 768 ? '0px' : '240px',
      margin: '0 auto',
      height: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
    menuItem: {
      marginTop: 'auto',
      marginBottom: 'auto',
      display: 'inline',
      verticalAlign: 'middle',
      color: '#141414',
      fontFamily: 'Roboto, sans-serif',
    },
    menuLogo: {
      width: '240px',
      marginTop: 16,
      marginBottom: 16,
    },
    logo: {
      width: 150,
      marginLeft: '38px',
      marginRight: 'auto',
      marginBottom: '16px',
    },
    sider: {
      backgroundColor: 'white',
      width: '400px',
    },
    chungungoLogo: {
      display: 'block',
      width: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    logoContainer: {
      width: '100%',
      marginTop: '36px',
      marginBottom: '36px',
    },
    menuItemIcon: {
      marginTop: 'auto',
      marginBottom: 'auto',
      width: 25,
      color: 'black',
    },
    loginButton: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      margin: 16,
    },
    navItem: {

    }
  };

  return (
    <Router>
      <Route render={({ location, history }) => {
        sendDataToGTM({ event: 'URL_CHANGE', value: location.pathname })
        reportEvent('url_change', {
          page: location.pathname,
        });
        if (goToAccount && location.pathname !== '/account') {
          return <Redirect to="/account" push />;
        }

        if (goToAccount && location.pathname === '/account') {
          setGoToAccount(false);
        }

        if (!getLoggedInUser() || goToLogin) {
          history.push("/");
          history.go();
        }

        return (
          <>
            <div className="contenedor-principal">

              <StyledSideNav
                className="shadow"
                style={{
                  minWidth: isMenuOpen ? navWidthExpanded : 0,
                  display: isMenuOpen ? 'block' : 'none',
                  position: 'fixed',
                  //marginTop: dimensions.width <= 768 ? '56px' : '0px',
                  marginTop: '56px',
                }}
                onSelect={(selected) => {
                  const to = '/' + selected;
                  if (location.pathname !== to && to !== '/search') {
                    setSearchText('');
                    history.push(to);
                  }
                }}
                expanded={isMenuOpen}
              > 
                <SideNav.Nav defaultSelected="seasons">
                  {menuItems
                    .map((menuItem) => (
                      <NavItem
                        key={menuItem.eventKey}
                        style={styles.navItem}
                        eventKey={menuItem.eventKey}
                        onSelect={() => setIsMenuOpen(false)}
                      >
                        <NavIcon>
                          <img style={styles.menuItemIcon} src={menuItem.icon} alt="" />
                        </NavIcon>
                        <NavText
                          style={styles.menuItem}
                        >
                          {t(`main.menu.${menuItem.eventKey}`)}
                        </NavText>
                      </NavItem>
                    ))}
                </SideNav.Nav>
              </StyledSideNav>
              
              <div
                style={styles.mainLayout}
              >
                {goToLogin &&
                  <LoginModal onClose={() => setGoToLogin(false)} />
                }
                <main
                  style={{
                    //dimensions.width <= 768 ? '100vw' : 'calc(100vw - 255px)',
                    width: '100vw',
                    maxWidth:'100%',
                    //marginTop: dimensions.width <= 768 ? 50 : 0,
                    marginTop: 50,
                    minHeight: 'calc(100vh - 150px)'
                  }}
                >

                    <Navbar
                      fixed="top"
                      style={{
                        backgroundColor: '#d6b600',
                      }}
                    >
                      <Button
                        variant="no-border"
                        className="float-right"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                      >
                        <span className="navbar-toggler-icon"></span>
                      </Button>
                      <Navbar.Brand className="mx-auto">
                        {location.pathname === '/search' &&
                          <input
                            className="formulario-busqueda__input"
                            type="text"
                            placeholder="Buscar"
                            value={searchText}
                            onFocus={(event) => {
                              if (location.pathname !== '/search')
                                history.push('/search');
                            }}
                            onChange={(event) => setSearchText(event.target.value)}
                          />
                        }

                        {location.pathname !== '/search' &&
                          <img
                            src={chungungoLogoMobile}
                            alt=""
                            style={{
                              height: 25,
                            }}
                          />
                        }

                      </Navbar.Brand>
                      <Navbar.Toggle aria-controls="basic-navbar-nav" />
                      <Button
                        variant="no-border"
                        className="float-right"
                        onClick={() => setGoToAccount(!isMenuOpen)}
                      >
                        <img
                          src={userIcon}
                          style={{
                            marginTop: -3,
                          }}
                          alt="cuenta"
                        />
                      </Button>
                      <Button
                        variant="no-border"
                        className="float-right"
                        onClick={(event) => { history.push('/search'); }}
                      >
                        <img src={searchIcon} alt="" />
                      </Button>
                    </Navbar>

                  <Switch>
                    <Route exact path="/seasons">
                      <Seasons />
                    </Route>
                    {seasonsRoutes.map((seasonRoute) => (
                      <Route key={seasonRoute.exploreKey} exact path={`/${seasonRoute.exploreKey}`}>
                      <ExploreRoute filterBy={seasonRoute.exploreKey} />
                      </Route>
                    ))}
                    <Route exact path="/seasons/:id">
                      <SeasonRoute />
                    </Route>
                    <Route exact path="/experiences/:id">
                      <ExperienceRoute />
                    </Route>
                    {menuItems.map((menuItem) => (
                      <Route key={menuItem.eventKey} exact path={`/${menuItem.eventKey}`}>
                        <CategoryRoute filterBy={menuItem.eventKey} searchBy={searchText} />
                      </Route>
                    ))}
                    <Route exact path="/search">
                      <CategoryRoute filterBy="search" searchBy={searchText} />
                    </Route>
                    <Route exact path="/account/subscribe/confirm">
                      <SuscribeConfirm />
                    </Route>
                    <Route exact path="/account/subscribe/success">
                      <SubscribeSuccess />
                    </Route>
                    <Route exact path="/account">
                      <Account />
                    </Route>
                    <Route exact path="/account/invoices">
                      <Invoices />
                    </Route>
                    <Route>
                      <Subscribe />
                    </Route>
                  </Switch>
                </main>
              </div>
            </div>
            <footer className="footerPayment d-lg-flex justify-content-lg-between"
              style={{
                paddingLeft: `${dimensions.width > 768 ? '260px' : '16px'}`,
              }}
            >
              <div className="d-lg-flex align-items-lg-center">
                <img className="mb-2 mb-lg-0" src={footerLogo} alt="" />
                <ul className="list-inline mb-3 mb-lg-0 ml-lg-4">
                  <li className="list-inline-item"><a href="/terms_and_conditions">Términos y Condiciones</a></li>
                  <li className="list-inline-item"><a href="/about">Acerca de</a></li>
                  <li className="list-inline-item"><a href="/faq">Preguntas Frecuentes</a></li>
                  <li className="list-inline-item"><a href="https://regala.chungungo.com/" target="_blank" rel="noreferrer">¿Quieres regalar Chungungo?</a></li>
                </ul>
              </div>
              <p className="m-0">Todos los derechos reservados© 2021 Chungungo SPA.</p>
            </footer>
          </>
        )
      }
      } >
      </Route>
    </Router>
  );
};

export default MainLayout;